import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableChart } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from "framer-motion";
import { EventEmitter } from '../../../utils';
import PopupWrapper from '../../PopupWrapper';

class Table extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      rows: 2,
      columns: 2,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.addTable = this.addTable.bind(this);
  }

  componentDidMount() {
    EventEmitter.listen('open-popup--table', () => {
      this.togglePopup();
    });
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  onChangeHandler(event) {
    this.setState({ [event.target.name]: Number(event.target.value) });
  }

  addTable(event) {
    event.preventDefault();
    this.props.editor.insertTable(this.state.columns, this.state.rows);
    this.togglePopup();
  }

  render() {
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--table">
          <button
            title="Table"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <TableChart />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
            <motion.div
              initial={{ opacity: 0, y: '80%' }}
              animate={{ opacity: 1, y: '100%' }}
              exit={{ opacity: 0, y: '80%' }}
              transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
              className="icon__popup icon__popup--table">
              <label
                htmlFor="rows"
                className="flex justify-between text-sm mb-5 whitespace-no-wrap font-bold">
                Rows
                <input
                  className="normal-border-sm rounded-sm ml-5 p-1"
                  type="number"
                  id="rows"
                  name="rows"
                  min="2"
                  onChange={this.onChangeHandler}
                  value={this.state.rows}
                />
              </label>
              <label
                htmlFor="columns"
                className="flex justify-between text-sm mb-5 whitespace-no-wrap font-bold">
                Columns
                <input
                  className="normal-border-sm rounded-sm ml-5 p-1"
                  type="number"
                  id="columns"
                  name="columns"
                  min="2"
                  onChange={this.onChangeHandler}
                  value={this.state.columns}
                />
              </label>
              <button
                onClick={this.addTable}
                className="normal-button rounded p-1 font-bold cursor-pointer w-full">
                Add Table
              </button>
            </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  Table;
